define('modules/start/groupCPSAgreementsModal/view',['require','exports','module','views/BaseView','env','helpers/viewHelpers','i18n','ldsh!./template'],function (require, exports, module) {
  'use strict';

  var BaseView = require('views/BaseView'),
    Config = require('env'),
    ViewHelpers = require("helpers/viewHelpers"),
    i18n = require('i18n');

  var GroupAgreementsModal = BaseView.extend({
    template: require('ldsh!./template'),
    events: {
      'click #acceptTerms': 'acceptTerms',
      'click #dismissTerms': 'dismissTerms',
      'click #groupCPSAcceptTermsCheckbox': 'checkAgreementsCheckbox',
    },

    getExternalTermsURL: function () {
      var lang = i18n.lng();
      var output;

      // Our version of JSHint needs this ugly structure!
      switch (lang) {
        case 'es':
          output = Config.CPSAgreements.externalTermsURL.es;
          break;
        case 'en':
          output = Config.CPSAgreements.externalTermsURL.en;
          break;
        case 'it':
          output = Config.CPSAgreements.externalTermsURL.it;
          break;
        default:
          output = Config.CPSAgreements.externalTermsURL.en;
      }

      return output;
    },

    serialize: function () {
      var CPSParams = {
        cpsExternalURL: this.getExternalTermsURL(),
        canBeDelayed: Config.CPSAgreements.canBeDelayed,
      };

      return CPSParams;
    },

    getAcceptTermsCheckbox: function () {
      return $('#groupCPSAcceptTermsCheckbox');
    },

    getAcceptTermsCheckboxContainer: function () {
      return $('.acceptTermsCheckboxContainer');
    },

    getActionButton: function () {
      return $('#acceptTerms');
    },

    checkAgreementsCheckbox: function () {
      if (!this.getAcceptTermsCheckbox().is(':checked')) {
        this.showErrorLayer();
        this.getActionButton().attr('disabled', 'disabled');
      } else {
        this.getActionButton().removeAttr('disabled');
        this.hideErrorLayer();
      }
    },

    showErrorLayer: function () {
      this.getAcceptTermsCheckboxContainer().addClass('error');
    },

    hideErrorLayer: function () {
      this.getAcceptTermsCheckboxContainer().removeClass('error');
    },

    acceptTerms: function () {
      this.checkAgreementsCheckbox();

      if (this.getActionButton().attr('disabled')) {
        return false;
      }

      var requestParams = {
        agreementsName: this.model.isAppSumo() ? 'APPSUMO' : 'CPS'
      },
        success = function () {
          location.reload();
        };

      this.model.save(requestParams, { success: success });
    },

    dismissTerms: function () {
      ViewHelpers.setCookie(
        Config.CPSAgreements.cookieDismissName,
        Config.CPSAgreements.cookieDismissValue,
        Config.CPSAgreements.cookieDismissExpirationDays
      );

      location.reload();
    }
  });

  module.exports = GroupAgreementsModal;
});

